const dashboardMessages = {
  ar: {
    credits: ({count}) => `Credits ${count}`,
    plan_ai: "AI Training",
    plan_basic: "Basic Training",
    plan_promo: "الخطة التجريبية",
    plan_free: "Free",
  },
};

export const createDashboardT =
  (locale = "ar") =>
  (key, params = {}) => {
    const dictionary = dashboardMessages[locale] || dashboardMessages.ar;
    const value = dictionary[key];
    if (typeof value === "function") {
      return value(params);
    }
    return value ?? key;
  };

export const getDashboardPlanLabel = (plan, t = createDashboardT()) => {
  if (plan === "ai") return t("plan_ai");
  if (plan === "basic") return t("plan_basic");
  if (plan === "promo") return t("plan_promo");
  return t("plan_free");
};

export {dashboardMessages};
